import './EFToastContent.css'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { EFToastContentProps } from './EFToastContent.model'
export function EFToastError(props: EFToastContentProps) {
  return (
    <div className='toast-error'>
      <ErrorOutlineIcon
        sx={{ height: 'var(--fs-title-md)', width: 'var(--fs-title-md)' }}
        color='error'
      />
      <span className='toast-message'> {props.text} </span>
    </div>
  )
}
